<template>
  <div class="space-y-4 my-10">
    <DropdownMenu>
      <DropdownMenuTrigger class="inline-flex items-center rounded-[6px] border px-3 py-2 text-sm">
        {{ selectedIndex !== null ? components[selectedIndex].name : 'Choose component…' }}
      </DropdownMenuTrigger>
      <DropdownMenuContent class="w-56">
        
        <div 
          v-for="(c, i) in components"
          :key="i"
          >
          <DropdownMenuItem
           
            @click="toggle(i)"
          >
            {{ c.name }}
          </DropdownMenuItem>
  
          <DropdownMenuSeparator v-if="i < components.length - 1" />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>

    <div v-if="selectedIndex !== null" class="p-6 bg-white shadow-md rounded-[8px]">
      <h2 class="text-xl font-semibold mb-4">
        {{ components[selectedIndex].name }}
      </h2>
      <div>
        <component :is="components[selectedIndex].component" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import DefaultLayoutV2 from '@/Layouts/DefaultV2.vue';

defineOptions({
  layout: DefaultLayoutV2,
});

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

import ButtonsPreview from './components/ButtonsPreview.vue';
import TypographyPreview from './components/TypographyPreview.vue';
import InputsPreview from './components/InputsPreview.vue';
import ToastersPreview from './components/ToastersPreview.vue';
import DialogsPreview from './components/DialogsPreview.vue'; 

const components = [
  { name: 'Buttons', component: ButtonsPreview },
  { name: 'Typography', component: TypographyPreview },
  { name: 'Inputs', component: InputsPreview },
  { name: 'Toasters', component: ToastersPreview },
  { name: 'Dialogs', component: DialogsPreview },
]

const selectedIndex = ref<number | null>(null)

function toggle(i: number) {
  selectedIndex.value = selectedIndex.value === i ? null : i
}
</script>
